import { render } from "./QuanTriDanhMuc.vue?vue&type=template&id=4ac2e85d&scoped=true"
import script from "./QuanTriDanhMuc.vue?vue&type=script&lang=js"
export * from "./QuanTriDanhMuc.vue?vue&type=script&lang=js"

import "./QuanTriDanhMuc.vue?vue&type=style&index=0&id=4ac2e85d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac2e85d"]])

export default __exports__